module.exports = __webpack_public_path__ + "static/media/AmrutCup.730c05f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AmrutCup.png
// module id = 230
// module chunks = 0